import { BaseRequest } from "./BaseRequest";

export class AccessKeyRequest extends BaseRequest {
    OwnerIdentity: string;
    Purpose: string;
    Expiration: number;

    constructor(ownerIdentity: string, purpose: string, expiration: number, clusterName: string) {
        super();
        this.OwnerIdentity = ownerIdentity;
        this.Purpose = purpose;
        this.Expiration = expiration;
        this.ClusterName = clusterName;
    }
}

